<div class="integration_page">
    <div class="integration_left">
        <div class="left_top">
            Manage Integration's
        </div>
        <div class="left_bottom">
            <ul>
                <li *nonProjectFeatureVisible="'GITHUB_INTEGRATION'" [class.active]="activeTab === 'github'">
                    <a [nonProjectFeatureNavState]="'GITHUB_INTEGRATION'" (click)="navigateTo('github')">
                        Git's
                    </a>
                </li>
                <li *nonProjectFeatureVisible="'JIRA_INTEGRATION'" [class.active]="activeTab === 'jira'">
                    <a [nonProjectFeatureNavState]="'JIRA_INTEGRATION'" (click)="navigateTo('jira')">
                        Jira's
                    </a>
                </li>
                <li *nonProjectFeatureVisible="'AGILE_INTEGRATION'" [class.active]="activeTab === 'agile-studio'">
                    <a [nonProjectFeatureNavState]="'AGILE_INTEGRATION'" (click)="navigateTo('agile-studio')">
                        Agile's
                    </a>
                </li>
                 <li *nonProjectFeatureVisible="'SLACK_INTEGRATION'" [class.active]="activeTab === 'slack'">
                    <a [nonProjectFeatureNavState]="'SLACK_INTEGRATION'" (click)="navigateTo('slack')">
                        Slack's
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="integration_right">
        <router-outlet></router-outlet>
    </div>
</div>